/**
 * Application entry point for the StartUs Admin Panel.
 *
 * This file initializes the React application, sets up internationalization,
 * and renders the root App component into the DOM. It serves as the bridge
 * between the HTML template and the React component tree.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './i18n';
import App from './App.tsx';
import { initSentry, Sentry } from '@startus/lib';

initSentry({ appName: 'admin' });

createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>}>
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>
  </Sentry.ErrorBoundary>
);
